import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { ErrorText, Spinner } from "@/components/kit";

export default function AuthCallback() {
  const done = useRef(false);
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const next = sessionStorage.getItem("condoor_next") || "/work";
    sessionStorage.removeItem("condoor_next");
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: match ? decodeURIComponent(match[1]) : "" });
        await refresh();
        navigate(next, { replace: true });
      } catch (e) {
        setError(errMsg(e));
        await refresh();
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="mx-auto max-w-md p-10">
      {error ? (
        <div className="space-y-3">
          <ErrorText data-testid="google-auth-error">{error}</ErrorText>
          <a href="/" className="text-sm font-medium text-[#0F5E59]">Back to Condoor</a>
        </div>
      ) : (
        <Spinner label="Signing you in" />
      )}
    </div>
  );
}
